import React from "react";
import Header from "../../UserManagement/Components/Header";

const EscrowCommissionTab = () => {
  return (
    <div>
      <div>
        <Header
          title={"Escrow and Commission"}
          // subTitle={"Product revenue, platform fees, and commission tracking"}
        />
      </div>
    </div>
  );
};

export default EscrowCommissionTab;
